import React from "react";
import { Alert as AlertAntd, Col, Row, Tag, Typography } from "antd";
import { TrapStatusData } from "../../types";
import ArchiveBoxIcon from "@heroicons/react/24/outline/ArchiveBoxIcon";
import { formatDate } from "../../utils/helpers";

const { Text } = Typography;

type Props = {
  item: TrapStatusData;
  onClick?: (id: string) => void;
};

const AlertDialog: React.FC<Props> = ({ item, onClick }) => {
  return (
    <div
      key={item?._id}
      className={`alert-dialog-container trap-status-dialog--${item?.status === "needs_attention" ? "error" : "primary"}`}
    >
      <AlertAntd
        onClick={() => onClick && onClick(item?._id)}
        message={
          <Row
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
            }}
          >
            <Col style={{ flex: 1, minWidth: 0 }}>
              <Row>
                <Text className="font-bold">
                  {item?.trapsite_name} - {item?.name}
                </Text>
              </Row>
              <Row>
                <Text>{item?.gps}</Text>
              </Row>
              <Row>
                <Text>
                  As of {formatDate(new Date(item?.status_updated_at), { dateOnly: true })}
                </Text>
              </Row>
            </Col>
            <Col style={{ flexShrink: 0 }}>
              <Tag
                className={`status-tag ${item?.status === "online" ? "online" : "offline"}`}
              >
                {item?.status === "online"
                  ? "Online"
                  : item?.status === "needs_attention"
                    ? "Needs Attention"
                    : "Offline"}
              </Tag>
            </Col>
          </Row>
        }
        className={`trap-status-dialog`}
        showIcon
        icon={
          <ArchiveBoxIcon
            className="w-6 h-6 mt-1"
            style={{ color: "#0c4a6e" }}
          />
        }
      />
    </div>
  );
};

export default AlertDialog;
